var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c(
      "div",
      { staticClass: "page-titles border-bottom" },
      [
        _c("h3", [_vm._v("AI Marketing Docs")]),
        _vm._v(" "),
        _c("sort-by", {
          staticClass: "pull-right",
          attrs: {
            "order-by-options": _vm.orderByOptions,
            "sort-by": _vm.filterUserForm.sort_by,
            order: _vm.filterUserForm.order,
          },
          on: {
            updateSortBy: (value) => {
              _vm.filterUserForm.sort_by = value
            },
            updateOrder: (value) => {
              _vm.filterUserForm.order = value
            },
          },
        }),
        _vm._v(" "),
        !_vm.showFilterPanel
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm pull-right m-r-10",
                on: {
                  click: function ($event) {
                    _vm.showFilterPanel = !_vm.showFilterPanel
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-filter" }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v(_vm._s(_vm.trans("general.filter"))),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.trans("general.filter"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(_vm._s(_vm.trans("user.name"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterUserForm.name,
                                    expression: "filterUserForm.name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "name", name: "name" },
                                domProps: { value: _vm.filterUserForm.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterUserForm,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v(_vm._s(_vm.trans("user.email"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterUserForm.email,
                                    expression: "filterUserForm.email",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "email", name: "email" },
                                domProps: { value: _vm.filterUserForm.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterUserForm,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "status" } }, [
                                _vm._v("Premium"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.is_premium,
                                      expression: "filterUserForm.is_premium",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "status" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "is_premium",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("general.select_one"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("No"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Yes"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "status" } }, [
                                _vm._v(_vm._s(_vm.trans("user.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.status,
                                      expression: "filterUserForm.status",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "status" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "status",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("general.select_one"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "activated" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("user.status_activated")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "pending_activation" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "user.status_pending_activation"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "pending_approval" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "user.status_pending_approval"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "banned" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("user.status_banned"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "disapproved" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("user.status_disapproved")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showFilterPanel
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm pull-right",
                                on: {
                                  click: function ($event) {
                                    _vm.showFilterPanel = !_vm.showFilterPanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.users.total
          ? _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm.hasPermission("list-user") && _vm.users.total
                    ? _c("div", { staticClass: "table-responsive" }, [
                        _c("table", { staticClass: "table table-hover" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.first_name"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.last_name"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.email"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v("Premium"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "table-option",
                                  attrs: { scope: "col" },
                                },
                                [_vm._v(_vm._s(_vm.trans("general.action")))]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.users.data, function (user) {
                              return user.investors.length
                                ? _c("tr", [
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.first_name
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.last_name
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(user.email),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.is_premium ? "Yes" : "No"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      _vm._l(
                                        _vm.getUserStatus(user),
                                        function (status) {
                                          return _c(
                                            "span",
                                            {
                                              class: [
                                                "label",
                                                "label-" + status.color,
                                                "m-r-5",
                                              ],
                                            },
                                            [_vm._v(_vm._s(status.label))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "table-option" }, [
                                      _c("div", { staticClass: "btn-group" }, [
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Presentation",
                                                expression: "'Presentation'",
                                              },
                                            ],
                                            staticClass: "btn btn-info btn-sm",
                                            attrs: {
                                              href: "/ps2/" + user.id + "/pdf",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-file-alt",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Fact Sheet",
                                                expression: "'Fact Sheet'",
                                              },
                                            ],
                                            staticClass: "btn btn-info btn-sm",
                                            attrs: {
                                              href:
                                                "/account/users/general-partners/" +
                                                user.id +
                                                "/fact-sheet-v2",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-file-alt",
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e()
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("pagination-record", {
                    attrs: {
                      "page-length": _vm.filterUserForm.page_length,
                      records: _vm.users,
                    },
                    on: {
                      "update:pageLength": function ($event) {
                        return _vm.$set(
                          _vm.filterUserForm,
                          "page_length",
                          $event
                        )
                      },
                      "update:page-length": function ($event) {
                        return _vm.$set(
                          _vm.filterUserForm,
                          "page_length",
                          $event
                        )
                      },
                      updateRecords: _vm.getUsers,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }